import { useSaveActions } from "../../common"
import { TableName } from "../../../tables"
import { PaymentType } from "../state/types"

export const usePaymentTypeActions = () => {
    const saveActions = useSaveActions()

    const savePaymentType = (paymentType: PaymentType) => {
        const { save } = saveActions()
        return save(TableName.PAYMENT_TYPES, paymentType) as Promise<PaymentType>
    }

    const removePaymentType = (id: string) => {
        const { remove } = saveActions()
        return remove(TableName.PAYMENT_TYPES, id)
    }

    return {
        savePaymentType,
        removePaymentType
    }
}
